import React from 'react';
import PropTypes, { string } from 'prop-types';
import { useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';

import { ReactComponent as FolderIcon } from 'assets/icon-folder.svg';
import { ReactComponent as OpenFolderIcon } from 'assets/icon-folder-open.svg';
import { ReactComponent as CaretDownIcon } from 'assets/icon-angle-down.svg';
import { ReactComponent as CaretUpIcon } from 'assets/icon-angle-up.svg';
import { ReactComponent as FolderNewIcon } from 'assets/icon-folder-new.svg';
import { ReactComponent as EditIcon } from 'assets/icon-edit.svg';
import { ReactComponent as TrashIcon } from 'assets/icon-trash.svg';

import { ButtonIcon } from 'shared/components/Buttons';

import { CustomFolderProps } from 'shared/prop-types/ReducerProps';

import { CustomFoldersDataWrapper, CustomFolderTreeWrapper } from './styles';

const CustomFoldersData = ({
  folders,
  onClickFolder,
  onEditFolder,
  onEditSubfolder,
  onDeleteFolder,
  onNewSubfolder,
  folderRoot,
}) => {
  const { selectedDefaultLanguage } = useSelector((state) => state.topBar);
  const getCaretIcon = (folder) => {
    if (
      (folder.childsFolders && folder?.childsFolders?.length > 0) ||
      (folder.childs && folder?.childs?.length > 0)
    ) {
      return folder.isOpen ? (
        <CaretUpIcon className="caret" />
      ) : (
        <CaretDownIcon className="caret" />
      );
    }
    return null;
  };

  const getNameSelectedLanguage = (i18List) => {
    const findName = i18List.find((x) => x.i18Code === selectedDefaultLanguage);
    if (findName && findName?.i18Name !== '') {
      return findName?.i18Name;
    }
    return i18List[0].i18Name;
  };

  const CustomFolderTree = ({ listItem, level }) => {
    return listItem
      ? listItem.map((item) =>
          item.id ? (
            <React.Fragment key={item.id}>
              <CustomFolderTreeWrapper
                className="item-data-container"
                level={level}
                onClick={() => onClickFolder(item.id)}
              >
                <div id={`toggle-custom-folder${item.id}`} className="info-container">
                  {(item.isOpen && item.childsFolders && item?.childsFolders?.length > 0) ||
                  (item.childs && item?.childs?.length > 0) ? (
                    <OpenFolderIcon className="folder-icon" />
                  ) : (
                    <FolderIcon className="folder-icon" />
                  )}
                  <span className="text-file">{getNameSelectedLanguage(item.i18List)}</span>
                  {getCaretIcon(item)}
                </div>
                <div className="actions">
                  <ButtonIcon
                    id={`${item.id}_subFolder`}
                    Icon={() => <FolderNewIcon />}
                    onClick={() => onNewSubfolder(item)}
                  />
                  <ButtonIcon
                    id={`${item.id}_edit`}
                    Icon={() => <EditIcon />}
                    onClick={() => (level === 1 ? onEditFolder(item) : onEditSubfolder(item))}
                  />
                  <ButtonIcon
                    id={`${item.id}_remove`}
                    Icon={() => <TrashIcon />}
                    onClick={() => onDeleteFolder(item)}
                  />
                </div>
              </CustomFolderTreeWrapper>
              <Collapse isOpen={item.isOpen}>
                {folders?.some((currentFolder) => {
                  const pathIds = currentFolder.pathId.split('/');
                  const clearedPathIds = pathIds.filter((x) => x.length > 0);
                  const parentId = clearedPathIds[clearedPathIds.length - 2];
                  return parentId === item.id;
                }) ? (
                  <CustomFolderTree
                    listItem={folders.filter((currentFolder) => {
                      const pathIds = currentFolder.pathId.split('/');
                      const clearedPathIds = pathIds.filter((x) => x.length > 0);
                      const parentId = clearedPathIds[clearedPathIds.length - 2];
                      return parentId === item.id;
                    })}
                    level={level + 1}
                  />
                ) : null}
              </Collapse>
            </React.Fragment>
          ) : null
        )
      : null;
  };

  CustomFolderTree.propTypes = {
    listItem: PropTypes.arrayOf(CustomFolderProps).isRequired,
    level: PropTypes.number.isRequired,
  };

  return (
    <CustomFoldersDataWrapper>
      <CustomFolderTree
        listItem={folders.filter((folder) => {
          const pathIds = folder.pathId.split('/');
          const clearedPathIds = pathIds.filter((x) => x.length > 0);
          const parentId = clearedPathIds[clearedPathIds.length - 2];
          return parentId === folderRoot.id;
        })}
        level={1}
      />
    </CustomFoldersDataWrapper>
  );
};

CustomFoldersData.propTypes = {
  folders: PropTypes.arrayOf(CustomFolderProps).isRequired,
  folderRoot: PropTypes.shape({
    id: string,
    pathId: string,
  }).isRequired,
  onClickFolder: PropTypes.func.isRequired,
  onEditFolder: PropTypes.func.isRequired,
  onEditSubfolder: PropTypes.func.isRequired,
  onDeleteFolder: PropTypes.func.isRequired,
  onNewSubfolder: PropTypes.func.isRequired,
};

export default CustomFoldersData;
